import './App.css';
import './index.css';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home.js';
import EmbeddedHome from './pages/EmbeddedHome';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ConfigPage from './pages/ConfigPage';
import Subscribe from './pages/Subscribe';
import PrivateEvents from './pages/PrivateEvents';
import Community from './pages/Community.js';
import HomeOld from './pages/HomeOld.js';
import NotFound from './pages/NotFound.js';
import LandscapeWarning from './components/LandscapeWarning';
import SkylineWatermark from './components/calendar/SkylineWatermark';
import config from './config';
import { useEffect, useState } from 'react';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import TextScaleToggle from './components/TextScaleToggle';

function MobileHeader({ showMobileMenu, setShowMobileMenu }) {
  const { theme, themeName, toggleTheme } = useTheme();
  return (
    <div className={`block md:hidden flex items-center justify-between shadow-sm h-10 ${theme.background} ${theme.text} pb-2 pt-2 pl-2 pr-2`}>
      <div className="flex items-center text-center">
        <div className="flex items-center"></div>
        <Link to="/" className="flex items-center">
          <img src="favicon-32x32.png" alt="ATLTech.events" className="h-8 w-8 object-contain" />
          <span className="flex text-center w-full ml-2 font-bold text-lg">ATLTech.events</span>
        </Link>
      </div>
      <div className="flex items-center gap-1">
        <TextScaleToggle compact />
        <button
          onClick={toggleTheme}
          className={`rounded-lg h-8 w-8 flex items-center justify-center ${theme.viewButtonInactive}`}
          aria-label={themeName === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={themeName === 'dark' ? 'Light mode' : 'Dark mode'}
        >
          <i className={`fas fa-${themeName === 'dark' ? 'sun' : 'moon'} text-sm`} aria-hidden="true"></i>
        </button>
        <button
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          className={`rounded-lg h-8 w-8 flex items-center justify-center ${theme.viewButtonInactive}`}
          aria-label="Toggle navigation menu"
          aria-expanded={showMobileMenu}
        >
          <i className={`fas fa-${showMobileMenu ? 'times' : 'bars'} text-xl`}></i>
        </button>
      </div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const isEmbedded = location.pathname === '/embed';
  const isHomePage = location.pathname === '/';
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const { theme, themeName, toggleTheme } = useTheme();
  
  useEffect(() => {
    // Check for app updates
    const currentVersion = localStorage.getItem('app_version');
    const currentBuildTime = localStorage.getItem('app_build_time');
    
    if (currentVersion !== config.appVersion) {
      // Clear cache and reload
      localStorage.clear();
      localStorage.setItem('app_version', config.appVersion);
      window.location.reload(true);
    }
  }, []);

  // If we're embedded and not on the /embed route, render the embedded version
  if (isEmbedded && !location.pathname.startsWith('/embed')) {
    return <EmbeddedHome />;
  }

  return (
    
    <div className={`App min-h-screen flex flex-col ${
      !isEmbedded && isHomePage ? "xl:bg-[url('atltechevents.png')] bg-[url('atltechevents-bg.png')] bg-fixed xl:bg-cover bg-center bg-no-repeat" : ""
    } h-screen`} style={{ background: theme.tokens.colors.bg, color: theme.tokens.colors.ink }}>

        <link 
            rel="stylesheet" 
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" 
            integrity="sha512-9usAa10IRO0HhonpyAIVpjrylPvoDwiPUiKdWk5t3PyolY1cOd4DSE0Ga+ri4AuTroPR5aQvXU9xC6qOPnzFeg==" 
            crossOrigin="anonymous" 
            referrerPolicy="no-referrer" 
          />


      {!isEmbedded && (
        <>
          <a 
            href="#main-content" 
            className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-white focus:text-black focus:outline-none"
          >
            Skip to main content
          </a>

          <LandscapeWarning />

        <MobileHeader showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
        {showMobileMenu && (
          <div className={`block md:hidden ${theme.background} ${theme.text} shadow-lg`}>
            <nav className="flex flex-col p-4" role="navigation" aria-label="Mobile navigation">
              <Link to="/" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Home</Link>
              <Link to="/about" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>About</Link>
              <Link to="/community" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Community</Link>
              <Link to="/subscribe" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Subscribe</Link>
              <Link to="/privacy" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Privacy</Link>
              <Link to="/terms" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Terms</Link>
              <hr className="my-2" />
              <span className="">Brought to you by <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com">Mirability<sup>SM</sup></a></span>
               <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com"> <img src="logo-black-transparent-300.png" alt="Mirability" className="max-h-10 object-contain mx-auto" /></a>
              <div className="text-xs md:text-sm border-t border-gray-200 pt-2 mt-2">
            <p>ATLTech.events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
            <p>Copyright 2026 Mirability, LLC. All Rights Reserved.</p>
            </div>
            </nav>
          </div>
        )}

        </>
      )}

      {!isEmbedded && !isHomePage && (
        <div id="top-nav-container" className="hidden md:block" style={{ background: theme.tokens.colors.surface, borderBottom: `1px solid ${theme.tokens.colors.gridLine}`, fontFamily: theme.tokens.fonts.ui }}>
          <div className="px-6 py-2">
            <div className="flex items-center justify-between gap-4">

              {/* Left: brand + BETA pill */}
              <div className="flex items-center gap-2.5">
                <Link to="/" className="flex items-center gap-2.5">
                  <img src="favicon-32x32.png" alt="" className="h-8 w-8 object-contain" />
                  <span style={{ fontFamily: theme.tokens.fonts.display, fontSize: 19, fontWeight: 600, color: theme.tokens.colors.ink, lineHeight: 1 }}>
                    ATLTech<span style={{ fontFamily: theme.tokens.fonts.mono, fontSize: 16, fontWeight: 500, color: theme.tokens.colors.accent }}>.events</span>
                  </span>
                </Link>
                <span style={{
                  fontFamily: theme.tokens.fonts.mono, fontSize: 9.5, letterSpacing: 0.6, fontWeight: 500,
                  color: theme.tokens.colors.accent, border: `1px solid ${theme.tokens.colors.accent}`, borderRadius: 4, padding: '2px 5px', opacity: 0.9,
                }}>BETA</span>
              </div>

              {/* Right: nav links + theme toggle + Mirability */}
              <div className="flex flex-col items-end gap-1">
                <div className="flex items-center gap-4 text-[13px] font-medium">
                  <Link to="/" className={theme.navLink}>Home</Link>
                  <Link to="/about" className={theme.navLink}>About</Link>
                  <Link to="/community" className={theme.navLink}>Community</Link>
                  <Link to="/subscribe" className={theme.navLink}>Subscribe</Link>
                  <button
                    onClick={toggleTheme}
                    className="flex items-center justify-center"
                    style={{ width: 30, height: 30, borderRadius: 8, border: `1px solid ${theme.tokens.colors.gridLine}`, color: theme.tokens.colors.muted }}
                    aria-label={themeName === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                    title={themeName === 'dark' ? 'Light mode' : 'Dark mode'}
                  >
                    <i className={`fas fa-${themeName === 'dark' ? 'sun' : 'moon'}`} aria-hidden="true"></i>
                  </button>
                </div>
                <span style={{ fontSize: 10.5, color: theme.tokens.colors.faint, whiteSpace: 'nowrap' }}>
                  Brought to you by <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com" style={{ color: theme.tokens.colors.muted, fontWeight: 600 }}>Mirability<sup>SM</sup></a>
                </span>
              </div>

            </div>
          </div>
        </div>
      )}

<div id="scroll-here"></div>

      <main
        id="main-content"
        className="flex-grow relative"
        role="main"
      >
        {!isEmbedded && !isHomePage && (
          <SkylineWatermark
            tokens={theme.tokens}
            containerHeight="44%"
            svgWidth="70%"
            svgMaxWidth={1200}
          />
        )}
        <div style={{ position: 'relative', zIndex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/embed" element={<EmbeddedHome />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/config" element={<ConfigPage />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/private-events" element={<PrivateEvents />} />
          <Route path="/community" element={<Community />} />
          <Route path="/old" element={<HomeOld />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </div>
      </main>


      {!isEmbedded && !isHomePage && (
        <footer style={{
          background: theme.tokens.colors.surfaceAlt,
          borderTop: `1px solid ${theme.tokens.colors.gridLine}`,
          color: theme.tokens.colors.faint,
          fontFamily: theme.tokens.fonts.ui,
          padding: '12px 24px',
          textAlign: 'center',
        }} role="contentinfo">
          <div className="container mx-auto">
            <nav className="mb-2" role="navigation" aria-label="Footer navigation">
              <div className="flex justify-center gap-5" style={{ fontSize: 13 }}>
                <Link to="/privacy" style={{ color: theme.tokens.colors.muted }} className="hover:underline">Privacy</Link>
                <Link to="/terms" style={{ color: theme.tokens.colors.muted }} className="hover:underline">Terms</Link>
              </div>
            </nav>
            <div style={{ fontSize: 11 }}>
              <p>ATLTech.events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
              <p>Copyright 2026 Mirability, LLC. All Rights Reserved.</p>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
